/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Mode: * `local` - FCC installed locally * `fccDataCenter` - FCC installed in FCC Data Center device  Applicable only for TSS assigned to the business premises. 
 */
export enum FccInstallationTypeEnumDTO {
    LOCAL = 'local',
    FCC_DATA_CENTER = 'fccDataCenter'
}

export class ClsFccInstallationTypeEnumDTO {
    LOCAL = 'local';
    FCC_DATA_CENTER = 'fccDataCenter';
}

